<template>
  <div class="count-ver">
    <span>{{currentAge == 0 ? '<1' : currentAge}}</span>
    <span class="dire-wrp">
      <i class="up" @click="onUp"></i>
      <i class="down" @click="onDown"></i>
    </span>
  </div>
</template>

<script>

  export default {
    name: 'age-ctrl',
    props: {
      defaultAge: {
        type: Number | String,
        default: 0,
      },
    },
    data(){
      return {
        currentAge: +this.defaultAge,
      };
    },
    methods: {
      onUp(){
        if(this.currentAge < 17){
          this.currentAge++;
        }
        this.$emit('on-age', this.currentAge);
      },

      onDown(){
        if(this.currentAge > 0){
          this.currentAge--;
        }
        this.$emit('on-age', this.currentAge);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .count-ver{
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    position: relative;
    width: 90px;
    height: 36px;
    line-height: 36px;
    padding-left: 10px;
    font-size: 16px;
    background: #fff;
    box-sizing: border-box;
    border-radius: 4px;
    border: 1px solid #D6D7DC;
    vertical-align: top;

    &:nth-of-type(2n){
      margin-right: 0;
    }
    .dire-wrp{
      position: absolute;
      width: 30px;
      height: 100%;
      top: 0;
      right: 0;

      i{
        display: block;
        width: 100%;
        height: 18px;
        cursor: pointer;
      }
      .up{
        background: url("/static/images/components/up.png") no-repeat center bottom;
        &:hover{
          background: url("/static/images/components/up_hover.png") no-repeat center bottom;
        }
      }
      .down{
        background: url("/static/images/components/down.png") no-repeat center top;
        &:hover{
          background: url("/static/images/components/down_hover.png") no-repeat center top;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CheckInRoomNumber/age-ctrl.vue